module.exports = __webpack_public_path__ + "static/img/no-details.6890c2b8.png";